import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/Navbar";
import { Link, animateScroll as scroll } from "react-scroll";
import Intro from "./components/Intro";
import { Box, Divider, Stack } from "@chakra-ui/react";
import AboutMe from "./components/AboutMe";
import Work from "./components/Work";
import TechSkill from "./components/TechSkill";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <Box>
      <Navbar></Navbar>
      <Stack backgroundColor={"csdark"} margin={"auto"} alignItems={"center"} pb={10}>
        <Intro></Intro>
        <AboutMe></AboutMe>
        <Work></Work>

        <TechSkill></TechSkill>
        <Projects></Projects>

        <Contact></Contact>
      </Stack>
      <Footer></Footer>
    </Box>
  );
}

export default App;
